export default __webpack_public_path__ + "static/media/DB_IMG1106.0142b154.jpg";